module.exports = __webpack_public_path__ + "media/hph-26-06_research-and-innovation.3e34487a.webm";